// @flow weak

import shadows from './shadows';
import transitions from './transitions';
import createTypography from './typography';
import createBreakpoints from './breakpoints';
import createPalette from './palette';
import zIndex from './zIndex';
import createMixins from './mixins';

export interface ITheme {
  dir: string;
  palette: any;
  typography: any;
  shadows: any;
  transitions: any;
  mixins: any;
  breakpoints: any;
  zIndex: any;
}

export function createMuiTheme(config = {}) {
  const {
    palette = createPalette(),
    breakpoints = createBreakpoints(),
    mixins = createMixins(breakpoints),
    typography = createTypography(palette),
    ...more
  }: any = config;

  const theme: ITheme = {
    dir: 'ltr',
    palette,
    typography,
    shadows,
    transitions,
    mixins,
    breakpoints,
    zIndex,
    ...more,
  };

  return theme;
}

export default createMuiTheme;
